import { ButtonComp } from 'atoms/Buttons';
import ORDER_HISTORY from '../Constants/Constants';
import React, { useEffect, useState } from 'react';
import { addFavOrder } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import { useDispatch, useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { occasionRegex } from '@kfc-global/react-shared/constants/RegexConstant';

const OccassionComponent = props => {
  const dispatch = useDispatch();
  const { onCancel, cardInfo, tenantData } = props;
  const { tenantId } = tenantData;

  const [occasionNameArr, setOccasionNameArr] = useState([]);
  const [isNameExist, setIsNameExist] = useState(false);
  const [isInValid, setIsInValid] = useState(false);

  const { customerInfo } = useSelector(data => {
    return {
      customerInfo: data.profileReducer || {},
    };
  });

  const { customerId, basic: { phone: phoneNumber = '' } = {}, favouriteOrders = [] } = customerInfo || {};

  const { CANCEL, SAVE, OCCASSOIN_HEADING, OREDER_PLACEHOLDER, NAME_EXIST, OCCASION_NAME_VALIDATION } = ORDER_HISTORY;

  useEffect(() => {
    const occasionNameArray = [];
    favouriteOrders.map(item => occasionNameArray.push(item.name.toUpperCase()?.trim()));
    setOccasionNameArr(occasionNameArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [occasionName, setOccasionName] = useState('');

  const updateFavouriteOrder = () => {
    let occasionNameInput = occasionName?.trim();
    const index = occasionNameArr.indexOf(occasionNameInput?.toUpperCase());
    const valid = occasionRegex.test(occasionName);
    let occasionNameInputLength = occasionNameInput.replace(/ /g, '').length;
    if (!valid || occasionNameInputLength === 0 || occasionNameInputLength <= 2) {
      setIsInValid(true);
    } else if (valid && index >= 0) {
      setIsNameExist(true);
      setIsInValid(false);
    } else {
      const { id } = cardInfo;
      dispatch(
        addFavOrder(
          {
            customerId,
            tenantId,
            phoneNumber,
          },
          {
            orderId: id,
            name: occasionName,
          },
        ),
      );
      onCancel();
    }
  };

  const setOccasionNameHandler = e => {
    setOccasionName(e.target.value);
    setIsInValid(false);
    setIsNameExist(false);
  };

  return (
    <div>
      <div className='InputHeading'>{translateWithI18Next(OCCASSOIN_HEADING)}</div>
      <div className='inputLookUpNumbox'>
        <input
          value={occasionName}
          type='tel'
          data-testid='occasion-input'
          className={'occasion-input-box'}
          placeholder={translateWithI18Next(OREDER_PLACEHOLDER)}
          maxlength='11'
          required
          onChange={e => setOccasionNameHandler(e)}
        />
        {isNameExist && <span className='error-text'>{translateWithI18Next(NAME_EXIST)}</span>}
        {isInValid && <span className='error-text'>{translateWithI18Next(OCCASION_NAME_VALIDATION)}</span>}
      </div>
      <div className='buttonItems'>
        <ButtonComp
          data-testid='occasion-cancel-button'
          className='button whiteButton blackBorder closebtn-cls'
          onClick={e => onCancel()}
        >
          {translateWithI18Next(CANCEL)}
        </ButtonComp>
        <ButtonComp
          data-testid='submit-button'
          className='button blackButton blackBorder save-button'
          onClickHandler={updateFavouriteOrder}
        >
          {translateWithI18Next(SAVE)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default OccassionComponent;
